/* ==========================================================================================
   UK · multi-buy: the maths and the behaviour (snippets/uk-multibuy.liquid, sections/uk-multibuy-band.liquid).
   SAME ITEM ONLY (Tommy 08-10): every tier is counted per cart line (one variant), never across mixed items.
   Loaded (defer) by the product block and the band; safe to load twice.

   THE MATHS (one rule, also in the Liquid): Shopify's "Amount off products" percentage discount takes the
   money off per UNIT, rounded DOWN to the cent, times the quantity. Evidence: 66 of 66 real order lines of a
   product-targeted percentage code on this store (tools/mb_rounding_orders.py), e.g. 6 x $29.95 at 45% = $80.82
   off. So: each = price - floor(price x pct / 100); line = each x qty.
   window.ukMb.maths is pure (tools/mb_maths_test.mjs checks it against hand-worked cases).
   ========================================================================================== */
(function (root) {
  'use strict';
  if (root.ukMb && root.ukMb.maths) {
    if (root.ukMb.boot && root.document) root.ukMb.boot(root.document);
    return;
  }

  /* ---- maths (all money in cents) ---- */
  var parseTiers = function (s) {
    return String(s || '').split(',').map(function (pair) {
      var a = pair.split(':');
      return { q: parseInt(a[0], 10), p: parseFloat(a[1]) };
    }).filter(function (t) {
      return t.q > 1 && t.q < 1000 && t.p > 0 && t.p < 100;
    }).sort(function (a, b) { return a.q - b.q; });
  };
  var unitOff = function (price, pct) {
    price = Math.round(Number(price) || 0);
    return pct > 0 ? Math.floor(price * pct / 100 + 1e-9) : 0;
  };
  var each = function (price, pct) { return Math.round(Number(price) || 0) - unitOff(price, pct); };
  var line = function (price, qty, pct) {
    price = Math.round(Number(price) || 0);
    qty = Math.max(0, Math.floor(Number(qty) || 0));
    var off = unitOff(price, pct) * qty;
    return { full: price * qty, off: off, pay: price * qty - off };
  };
  var tierFor = function (count, tiers) {
    var t = null;
    tiers.forEach(function (x) { if (count >= x.q) t = x; });
    return t;
  };
  var nextFor = function (count, tiers) {
    for (var i = 0; i < tiers.length; i++) if (count < tiers[i].q) return tiers[i];
    return null;
  };
  // ONE item (one variant) bought qty times: its own tier, its own next step
  var item = function (price, qty, tiers) {
    qty = Math.max(0, Math.floor(Number(qty) || 0));
    var t = tierFor(qty, tiers), pct = t ? t.p : 0, l = line(price, qty, pct), nx = nextFor(qty, tiers);
    return { qty: qty, pct: pct, tier: t, full: l.full, off: l.off, pay: l.pay, next: nx, short: nx ? nx.q - qty : 0 };
  };
  // a cart: [{ price, qty }], one entry per line (= per variant). Each line on its own; never a pooled count.
  var cart = function (lines, tiers) {
    var out = { lines: [], full: 0, off: 0, pay: 0 };
    (lines || []).forEach(function (l) {
      var r = item(l.price, l.qty, tiers);
      out.lines.push(r); out.full += r.full; out.off += r.off; out.pay += r.pay;
    });
    return out;
  };
  // mb8: is this SKU on the list (",UKSQ444CL,UKRE740CL,")? No list = every item (the old rule).
  var listed = function (sku, list) {
    list = String(list == null ? '' : list).toUpperCase().replace(/\s+/g, '');
    if (!list.replace(/,/g, '')) return true;
    sku = String(sku == null ? '' : sku).toUpperCase().trim();
    return !!sku && (',' + list + ',').indexOf(',' + sku + ',') >= 0;
  };
  var maths = { listed: listed, parseTiers: parseTiers, unitOff: unitOff, each: each, line: line, tierFor: tierFor, nextFor: nextFor, item: item, cart: cart };

  var api = { maths: maths };
  root.ukMb = api;
  if (typeof root.document === 'undefined') return;   // the maths test runs here without a page

  /* ---- page helpers ---- */
  var D = root.document;
  var money = function (c) {
    if (root.BO && root.BO.money) return root.BO.money(c);
    return '$' + ((Number(c) || 0) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  var reduce = function () {
    return root.matchMedia ? root.matchMedia('(prefers-reduced-motion: reduce)').matches : false;
  };
  var fill = function (tpl, map) {
    return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) { return k in map ? map[k] : m; });
  };

  /* ---- tier buttons (product page block and the band's picker share them) ---- */
  var paintOpts = function (box, price) {
    var w = {
      each: box.getAttribute('data-w-each') || '[price] each',
      sum: box.getAttribute('data-w-sum') || '[qty] for [total]',
      save: box.getAttribute('data-w-save') || 'save [amount]'
    };
    box.querySelectorAll('.uk-mb__opt').forEach(function (b) {
      var p = +b.getAttribute('data-pct') || 0;
      var el = b.querySelector('[data-each]');
      if (el) el.textContent = fill(w.each, { price: money(each(price, p)) });
    });
    return w;
  };
  var lightOpts = function (box, qty, price, tiers) {
    var best = null;
    box.querySelectorAll('.uk-mb__opt').forEach(function (b) { if (+b.getAttribute('data-qty') <= qty) best = b; });
    box.querySelectorAll('.uk-mb__opt').forEach(function (b) {
      var on = b === best;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var sum = box.querySelector('[data-mb-sum]');
    if (!sum) return;
    var r = item(price, qty, tiers);
    var w = {
      sum: box.getAttribute('data-w-sum') || '[qty] for [total]',
      save: box.getAttribute('data-w-save') || 'save [amount]'
    };
    if (r.off > 0) {
      sum.textContent = fill(w.sum, { qty: qty, total: money(r.pay) }) + ', ' + fill(w.save, { amount: money(r.off), pct: r.pct });
      sum.hidden = false;
    } else {
      sum.textContent = '';
      sum.hidden = true;
    }
  };

  /* ================= product page tier block ================= */
  var qtyInput = function (box) {
    var id = box.getAttribute('data-form');
    var el = null;
    if (id) {
      el = D.querySelector('input[name="quantity"][form="' + id + '"]');
      var f = D.getElementById(id);
      if (!el && f) el = f.querySelector('input[name="quantity"]');
    }
    if (el) return el;
    var host = box.closest('.shopify-section') || D;
    var all = host.querySelectorAll('input[name="quantity"]');
    for (var i = 0; i < all.length; i++) {
      if (!all[i].closest('[data-uk-mb], cart-drawer, .uk-cd, [data-uk-mb-band]')) return all[i];
    }
    return null;
  };
  var bindProduct = function (box) {
    var tiers = parseTiers(box.getAttribute('data-tiers'));
    var base = parseFloat(box.getAttribute('data-base')) || 0;   // Tommy 08-10: 10% storewide is always on
    if (base > 0) tiers = [{ q: 1, p: base }].concat(tiers.filter(function (x) { return x.q > 1; }));
    var price = function () { return +box.getAttribute('data-price') || 0; };
    var light = function (q) { lightOpts(box, q, price(), tiers); };
    box.addEventListener('click', function (e) {
      var b = e.target.closest('.uk-mb__opt');
      if (!b) return;
      var q = +b.getAttribute('data-qty') || 1;
      var input = qtyInput(box);
      if (input) {
        input.value = q;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      light(q);
    });
    var host = box.closest('.shopify-section') || D;
    var follow = function (e) {
      var t = e.target;
      if (t && t.name === 'quantity' && t === qtyInput(box)) light(+t.value || 1);
    };
    host.addEventListener('input', follow);
    host.addEventListener('change', follow);
    // the theme's +/- buttons change the number without an input event
    host.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('[data-uk-qty], .quantity__button')) return;
      setTimeout(function () { var i = qtyInput(box); if (i) light(+i.value || 1); }, 0);
    });
    // uk-product.js: CustomEvent('uk:variant:change', { detail: { variant } }), price in cents
    // mb8: the block only for the listed SKUs, per variant (data-skus); it hides on any other colour
    var skus = box.getAttribute('data-skus');
    var wrap = box.parentElement && box.parentElement.classList.contains('ukp-mbwrap') ? box.parentElement : null;
    var show = function (on) {
      box.hidden = !on;
      if (wrap) wrap.hidden = !on;
    };
    if (skus != null) show(!box.hasAttribute('hidden'));
    host.addEventListener('uk:variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      if (skus != null) show(!!v && v.available !== false && listed(v.sku, skus));
      if (!v || v.price == null) return;
      box.setAttribute('data-price', Math.round(Number(v.price)));
      paintOpts(box, price());
      var i = qtyInput(box);
      light(i ? +i.value || 1 : 1);
    });
    paintOpts(box, price());
    var i0 = qtyInput(box);
    light(i0 ? +i0.value || 1 : 1);
  };

  /* ================= the band: ladder reveal + "pick one item" ================= */
  var bindBand = function (band) {
    var tiers = parseTiers(band.getAttribute('data-tiers'));
    // 1. the ladder rises in once when it comes into view (still and complete without motion)
    var stage = band.querySelector('[data-mb-stage]');
    if (stage) {
      if (reduce() || !('IntersectionObserver' in root)) stage.classList.add('is-in', 'is-still');
      else {
        stage.classList.add('is-armed');
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (en) {
            if (!en.isIntersecting) return;
            stage.classList.add('is-in');
            io.disconnect();
          });
        }, { threshold: 0.3 });
        io.observe(stage);
      }
    }

    // 2. the picker: ONE item, one colour, one quantity -> one cart line
    var pick = band.querySelector('[data-mb-pick]');
    if (!pick) return;
    var data = [];
    try { data = JSON.parse((pick.querySelector('script[data-mb-items]') || {}).textContent || '[]'); } catch (err) { data = []; }
    if (!data.length) return;
    var selItem = pick.querySelector('[data-mb-item-select]');
    var selVar = pick.querySelector('[data-mb-variant-select]');
    var varWrap = pick.querySelector('[data-mb-variant-wrap]');
    var img = pick.querySelector('[data-mb-img]');
    var link = pick.querySelector('[data-mb-link]');
    var cta = pick.querySelector('[data-mb-add]');
    var err = pick.querySelector('[data-mb-error]');
    var st = { i: 0, v: 0, qty: +pick.getAttribute('data-start') || 6 };
    var cur = function () { var it = data[st.i] || data[0]; return { it: it, v: it.variants[st.v] || it.variants[0] }; };
    var drawVariants = function () {
      var it = cur().it;
      if (!selVar) return;
      selVar.innerHTML = '';
      it.variants.forEach(function (v, k) {
        var o = D.createElement('option');
        o.value = k; o.textContent = v.title;
        selVar.appendChild(o);
      });
      selVar.value = String(st.v);
      if (varWrap) varWrap.hidden = it.variants.length < 2;
    };
    var paint = function () {
      var c = cur();
      if (img && c.v.img) { img.src = c.v.img; img.removeAttribute('srcset'); img.alt = c.it.name; }
      if (link) link.href = c.it.url;
      paintOpts(pick, c.v.price);
      lightOpts(pick, st.qty, c.v.price, tiers);
    };
    if (selItem) selItem.addEventListener('change', function () { st.i = +selItem.value || 0; st.v = 0; drawVariants(); paint(); });
    if (selVar) selVar.addEventListener('change', function () { st.v = +selVar.value || 0; paint(); });
    pick.addEventListener('click', function (e) {
      var b = e.target.closest('.uk-mb__opt');
      if (b) { st.qty = +b.getAttribute('data-qty') || 1; paint(); return; }
      var add = e.target.closest('[data-mb-add]');
      if (add) { e.preventDefault(); addOne(add); }
    });
    var addOne = function (btn) {
      var c = cur();
      if (!c.v || !c.v.id || btn.getAttribute('aria-busy') === 'true') return;
      if (err) err.textContent = '';
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-loading');
      var fd = new FormData();
      fd.append('items[0][id]', c.v.id);
      fd.append('items[0][quantity]', st.qty);
      var done = function () { btn.removeAttribute('aria-busy'); btn.classList.remove('is-loading'); };
      var fail = function (x) {
        done();
        if (err) err.textContent = (x && x.ukCart && x.message) || pick.getAttribute('data-w-error') || 'Sorry, that could not be added. Please try again.';
      };
      // BO.cart.add (uk-main.js) asks for the drawer's sections in the same call and opens the drawer
      if (root.BO && root.BO.cart && root.BO.cart.add) {
        root.BO.cart.add(fd, pick).then(function () {
          done();
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 2400);
        }).catch(fail);
      } else {
        fetch(((root.routes && root.routes.cart_add_url) || '/cart/add') + '.js', {
          method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (x) {
            if (!x.ok || x.j.status) { var er = new Error(x.j.description || x.j.message); er.ukCart = true; throw er; }
            root.location.href = (root.routes && root.routes.cart_url) || '/cart';
          }).catch(fail);
      }
    };
    drawVariants();
    paint();
    if (cta) cta.disabled = false;
  };

  /* ---- boot ---- */
  var boot = function (scope) {
    scope = scope || D;
    var pickAll = function (sel) {
      var list = Array.prototype.slice.call(scope.querySelectorAll(sel));
      if (scope.matches && scope.matches(sel)) list.unshift(scope);
      return list;
    };
    pickAll('[data-uk-mb="product"]').forEach(function (el) { if (el.ukMb) return; el.ukMb = true; bindProduct(el); });
    pickAll('[data-uk-mb-band]').forEach(function (el) { if (el.ukMb) return; el.ukMb = true; bindBand(el); });
  };
  api.boot = boot;
  api.money = money;

  D.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', function () { boot(D); });
  else boot(D);
})(typeof window !== 'undefined' ? window : globalThis);
